module.exports = __webpack_public_path__ + "images/kihnu/routes/RIN-MUN-RIN.png";